import React from 'react'
import ReactPlayer from 'react-player/lazy'
import { Button, Header, Icon, Modal ,Grid, Segment, Embed} from 'semantic-ui-react'

const ModalPlay = ({showModal, closeModal, idTipoContenido, datos}) => (
  <Modal open={showModal}  size='large'>
    <Header icon="play" content="Preview" />
    <Modal.Content>
     
        {datos.idTipoContenido==26   ?
        <div>
                <Header as='h3'>{datos.tituloContenido}</Header>
                
        
                <Embed
                    icon='right circle arrow'
                    placeholder='/images/image-16by9.png'
                    url={datos.urlContenido}
                    active={true}
                />
            <Grid>        
              
            </Grid>
        
        
        
        </div>
        :""}
        
        
        {datos.idTipoContenido==27   ?
            <div>
            
            <Grid >
                    <Grid.Row >
                        <Grid.Column>   
                            <Header as='h3'>{datos.tituloContenido}</Header>
                        </Grid.Column>
                </Grid.Row> 
                
                <Grid.Row >
                        <Grid.Column textAlign="center" >
                            <div style={{"height": "25em"}}>
                                <ReactPlayer url={datos.urlContenido}  
                                    
                                     width='50%'
                                     controls={true}
                                     playing={true}
                                    />
                                
                            </div>    
                         </Grid.Column>
                </Grid.Row>
                </Grid>

            </div>
        :""}
    </Modal.Content>
    <Modal.Actions>
      <Button basic color='gray' onClick={closeModal} >
         regresar
      </Button>
       
    </Modal.Actions>
  </Modal>
)

export default ModalPlay